import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import App from './App';
import AuthMiddleware from './Helpers/AuthMiddleware';
import { store } from './redux/store';
import './App.scss';
import { theme, globalStyles } from './Theme';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LanguageProvider } from 'LanguageProvider';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

/* if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/serviceWorker.js')
      .then(registration => {
        console.log('ServiceWorker registration successful with scope: ', registration.scope);
      })
      .catch(error => {
        console.log('ServiceWorker registration failed: ', error);
      });
  });
} */

root.render(
  <React.StrictMode>
    <LanguageProvider>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          {globalStyles}
          <CookiesProvider>
            <AuthMiddleware>
              <App />
            </AuthMiddleware>
          </CookiesProvider>
        </ThemeProvider>
      </Provider>
    </LanguageProvider>
  </React.StrictMode>
);
